var _path, _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 11.0378C0 5.14673 4.77563 0.371094 10.6667 0.371094H85.3333C91.2244 0.371094 96 5.14672 96 11.0378V85.7044C96 91.5955 91.2244 96.3711 85.3333 96.3711H10.6667C4.77563 96.3711 0 91.5955 0 85.7044V11.0378Z",
    fill: "url(#paint0_linear_1972_80267)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1972_80267",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 64,
    height: 65
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16.3594,
    width: 64,
    height: 64,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1972_80267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1374 51.4645C78.2341 50.9873 78.3312 50.5086 78.4266 50.0314V48.5323C78.3865 48.3386 78.3489 48.1444 78.3113 47.9502C78.2203 47.48 78.1294 47.0103 78.0026 46.5495C76.5692 41.3416 71.9168 37.812 66.4222 37.7642C64.8095 37.7523 63.1941 37.7562 61.5795 37.7602C60.7726 37.7622 59.9659 37.7642 59.1599 37.7642H58.3954L58.675 36.5115C58.8424 35.7606 59.0059 35.0275 59.1718 34.2943L59.2562 33.9255C59.4074 33.2646 59.5592 32.6007 59.7153 31.9412C60.002 30.7228 59.8467 30.3645 58.7836 29.7852H29.2513C29.2354 29.7971 29.2201 29.8104 29.2048 29.8236C29.1743 29.8502 29.1438 29.8767 29.108 29.8927C28.3793 30.2391 28.0747 30.7467 28.2061 31.3977C28.3435 32.0606 28.8332 32.4428 29.6037 32.4847C29.7273 32.4886 29.8536 32.4873 29.979 32.486C30.0414 32.4853 30.1036 32.4847 30.1651 32.4847H56.8665C55.3554 39.0916 53.8608 45.6361 52.3705 52.162L50.8165 58.966C50.1072 58.966 49.6812 58.9648 49.3638 58.964C48.6691 58.9621 48.4931 58.9616 47.0011 58.978C46.6236 58.9832 46.5683 58.7813 46.5038 58.5461C46.4949 58.5134 46.4857 58.4799 46.4755 58.4464C45.6095 55.5797 42.9996 53.6327 40.0732 53.6626C37.087 53.6984 34.5428 55.6633 33.7126 58.5778C33.6891 58.6679 33.6528 58.7502 33.6155 58.8349C33.5958 58.8795 33.5759 58.9247 33.5574 58.972C33.1147 58.972 32.6761 58.9713 32.2401 58.9706C31.3765 58.9693 30.5225 58.968 29.6694 58.972C28.7735 58.978 28.1703 59.5095 28.1703 60.2859C28.1643 61.0563 28.7616 61.5938 29.6574 61.6058C30.7981 61.6237 31.9389 61.6297 33.0796 61.6058C33.4797 61.5998 33.635 61.7312 33.7485 62.1254C34.5667 64.9563 37.1527 66.9033 40.0672 66.9212C43.0056 66.9391 45.5857 65.0459 46.4397 62.209C46.5771 61.7551 46.7562 61.5998 47.24 61.5998C51.1364 61.6139 53.3136 61.6132 56.4706 61.6123L59.9422 61.6118C61.2382 65.1593 63.4062 66.9092 66.464 66.9212C69.5458 66.9331 71.6779 65.225 73.0217 61.6715L73.0411 61.6614C73.0707 61.6457 73.1009 61.6297 73.1351 61.6297C73.3357 61.6277 73.5357 61.6264 73.7354 61.625C74.1362 61.6224 74.5362 61.6197 74.9388 61.6118C75.8466 61.5938 76.2826 61.2415 76.4438 60.3695C76.5942 59.565 76.7427 58.7604 76.8912 57.9559C77.1141 56.7481 77.3373 55.5392 77.5666 54.3315C77.7498 53.3758 77.9436 52.4202 78.1374 51.4645ZM74.0138 58.8228C74.0012 58.8647 73.9886 58.9064 73.9772 58.9481V58.9541H73.0276C71.7197 55.4065 69.4622 53.6029 66.4103 53.6745C63.4779 53.7462 60.7843 55.6394 59.9661 58.978H53.5817C54.9912 52.7727 56.3887 46.6272 57.7982 40.4398H61.6324C62.1167 40.4398 62.6015 40.4379 63.0865 40.4359C64.3 40.431 65.5151 40.4262 66.7268 40.4518C71.0687 40.5413 74.7118 43.5813 75.6376 47.8097C75.8944 48.9803 75.6853 50.0971 75.4644 51.2378C75.1458 52.8624 74.8432 54.4869 74.5406 56.1115C74.3893 56.9236 74.238 57.7358 74.0847 58.548C74.0684 58.6417 74.041 58.7327 74.0138 58.8228ZM66.4521 56.3322C68.6619 56.3203 70.4595 58.0821 70.4655 60.274L70.4715 60.268C70.4774 62.4539 68.6798 64.2695 66.4939 64.2695C64.314 64.2754 62.5103 62.4658 62.5103 60.2799C62.5163 58.106 64.2722 56.3501 66.4521 56.3322ZM40.0732 56.3322C42.3128 56.3262 44.0508 58.0582 44.0508 60.2979L44.0448 60.2919C44.0448 62.4897 42.3188 64.2456 40.1269 64.2695C37.9411 64.2933 36.1494 62.5016 36.1494 60.2859C36.1494 58.0821 37.8754 56.3442 40.0732 56.3322Z",
    fill: "url(#paint1_linear_1972_80267)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.894 53.6647C25.5301 53.6636 26.1671 53.6625 26.8026 53.6625H29.7887C30.5212 53.6625 30.6923 53.6661 30.8046 53.6684C30.943 53.6714 30.9923 53.6724 31.896 53.6625C32.8397 53.6505 33.4011 53.0354 33.2995 52.1694C33.2099 51.4527 32.6605 51.0287 31.7766 51.0287H19.1102C19.0769 51.0287 19.0436 51.0281 19.0104 51.0275C18.8949 51.0254 18.7809 51.0234 18.6742 51.0466C18.1427 51.1481 17.7783 51.4587 17.6171 51.9783C17.4618 52.48 17.5633 52.9816 17.9754 53.2683C18.3039 53.4953 18.7578 53.6446 19.1639 53.6446C21.0723 53.6715 22.984 53.6681 24.894 53.6647Z",
    fill: "url(#paint2_linear_1972_80267)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9647 46.5459H21.4967C20.9413 46.5459 20.4754 46.3966 20.1768 45.8949C19.705 45.1065 20.1708 44.0972 21.0786 43.924C21.2168 43.8984 21.3594 43.8992 21.5026 43.8999L21.5743 43.9001H34.3193C35.1913 43.9001 35.7348 44.2764 35.8602 44.9513C36.0274 45.8471 35.4302 46.528 34.4268 46.5339C32.9896 46.5419 31.5525 46.5392 30.1153 46.5366C29.3966 46.5353 28.6774 46.5339 27.9588 46.5339L27.9647 46.5459Z",
    fill: "url(#paint3_linear_1972_80267)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5992 39.2796C28.1253 39.278 28.6515 39.2764 29.1783 39.2764V39.2824C29.6606 39.2824 30.3742 39.2834 31.1863 39.2845C33.2001 39.2873 35.819 39.2909 37.0149 39.2824C37.3016 39.2764 37.6062 39.2645 37.869 39.1689C38.4543 38.9539 38.7529 38.3447 38.6394 37.7057C38.5259 37.0667 37.9944 36.6486 37.2359 36.6486H23.8748C23.1522 36.7143 22.6386 37.2518 22.6326 37.9506C22.6266 38.6911 23.1343 39.2585 23.9047 39.2705C25.1378 39.2872 26.3679 39.2834 27.5992 39.2796Z",
    fill: "url(#paint4_linear_1972_80267)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1374 51.4645C78.2341 50.9873 78.3312 50.5086 78.4266 50.0314V48.5323C78.3865 48.3386 78.3489 48.1444 78.3113 47.9502C78.2203 47.48 78.1294 47.0103 78.0026 46.5495C76.5692 41.3416 71.9168 37.812 66.4222 37.7642C64.8095 37.7523 63.1941 37.7562 61.5795 37.7602C60.7726 37.7622 59.9659 37.7642 59.1599 37.7642H58.3954L58.675 36.5115C58.8424 35.7606 59.0059 35.0275 59.1718 34.2943L59.2562 33.9255C59.4074 33.2646 59.5592 32.6007 59.7153 31.9412C60.002 30.7228 59.8467 30.3645 58.7836 29.7852H29.2513C29.2354 29.7971 29.2201 29.8104 29.2048 29.8236C29.1743 29.8502 29.1438 29.8767 29.108 29.8927C28.3793 30.2391 28.0747 30.7467 28.2061 31.3977C28.3435 32.0606 28.8332 32.4428 29.6037 32.4847C29.7273 32.4886 29.8536 32.4873 29.979 32.486C30.0414 32.4853 30.1036 32.4847 30.1651 32.4847H56.8665C55.3554 39.0916 53.8608 45.6361 52.3705 52.162L50.8165 58.966C50.1072 58.966 49.6812 58.9648 49.3638 58.964C48.6691 58.9621 48.4931 58.9616 47.0011 58.978C46.6236 58.9832 46.5683 58.7813 46.5038 58.5461C46.4949 58.5134 46.4857 58.4799 46.4755 58.4464C45.6095 55.5797 42.9996 53.6327 40.0732 53.6626C37.087 53.6984 34.5428 55.6633 33.7126 58.5778C33.6891 58.6679 33.6528 58.7502 33.6155 58.8349C33.5958 58.8795 33.5759 58.9247 33.5574 58.972C33.1147 58.972 32.6761 58.9713 32.2401 58.9706C31.3765 58.9693 30.5225 58.968 29.6694 58.972C28.7735 58.978 28.1703 59.5095 28.1703 60.2859C28.1643 61.0563 28.7616 61.5938 29.6574 61.6058C30.7981 61.6237 31.9389 61.6297 33.0796 61.6058C33.4797 61.5998 33.635 61.7312 33.7485 62.1254C34.5667 64.9563 37.1527 66.9033 40.0672 66.9212C43.0056 66.9391 45.5857 65.0459 46.4397 62.209C46.5771 61.7551 46.7562 61.5998 47.24 61.5998C51.1364 61.6139 53.3136 61.6132 56.4706 61.6123L59.9422 61.6118C61.2382 65.1593 63.4062 66.9092 66.464 66.9212C69.5458 66.9331 71.6779 65.225 73.0217 61.6715L73.0411 61.6614C73.0707 61.6457 73.1009 61.6297 73.1351 61.6297C73.3357 61.6277 73.5357 61.6264 73.7354 61.625C74.1362 61.6224 74.5362 61.6197 74.9388 61.6118C75.8466 61.5938 76.2826 61.2415 76.4438 60.3695C76.5942 59.565 76.7427 58.7604 76.8912 57.9559C77.1141 56.7481 77.3373 55.5392 77.5666 54.3315C77.7498 53.3758 77.9436 52.4202 78.1374 51.4645ZM74.0138 58.8228C74.0012 58.8647 73.9886 58.9064 73.9772 58.9481V58.9541H73.0276C71.7197 55.4065 69.4622 53.6029 66.4103 53.6745C63.4779 53.7462 60.7843 55.6394 59.9661 58.978H53.5817C54.9912 52.7727 56.3887 46.6272 57.7982 40.4398H61.6324C62.1167 40.4398 62.6015 40.4379 63.0865 40.4359C64.3 40.431 65.5151 40.4262 66.7268 40.4518C71.0687 40.5413 74.7118 43.5813 75.6376 47.8097C75.8944 48.9803 75.6853 50.0971 75.4644 51.2378C75.1458 52.8624 74.8432 54.4869 74.5406 56.1115C74.3893 56.9236 74.238 57.7358 74.0847 58.548C74.0684 58.6417 74.041 58.7327 74.0138 58.8228ZM66.4521 56.3322C68.6619 56.3203 70.4595 58.0821 70.4655 60.274L70.4715 60.268C70.4774 62.4539 68.6798 64.2695 66.4939 64.2695C64.314 64.2754 62.5103 62.4658 62.5103 60.2799C62.5163 58.106 64.2722 56.3501 66.4521 56.3322ZM40.0732 56.3322C42.3128 56.3262 44.0508 58.0582 44.0508 60.2979L44.0448 60.2919C44.0448 62.4897 42.3188 64.2456 40.1269 64.2695C37.9411 64.2933 36.1494 62.5016 36.1494 60.2859C36.1494 58.0821 37.8754 56.3442 40.0732 56.3322Z",
    stroke: "url(#paint5_linear_1972_80267)",
    strokeWidth: 2.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.894 53.6647C25.5301 53.6636 26.1671 53.6625 26.8026 53.6625H29.7887C30.5212 53.6625 30.6923 53.6661 30.8046 53.6684C30.943 53.6714 30.9923 53.6724 31.896 53.6625C32.8397 53.6505 33.4011 53.0354 33.2995 52.1694C33.2099 51.4527 32.6605 51.0287 31.7766 51.0287H19.1102C19.0769 51.0287 19.0436 51.0281 19.0104 51.0275C18.8949 51.0254 18.7809 51.0234 18.6742 51.0466C18.1427 51.1481 17.7783 51.4587 17.6171 51.9783C17.4618 52.48 17.5633 52.9816 17.9754 53.2683C18.3039 53.4953 18.7578 53.6446 19.1639 53.6446C21.0723 53.6715 22.984 53.6681 24.894 53.6647Z",
    stroke: "url(#paint6_linear_1972_80267)",
    strokeWidth: 2.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9647 46.5459H21.4967C20.9413 46.5459 20.4754 46.3966 20.1768 45.8949C19.705 45.1065 20.1708 44.0972 21.0786 43.924C21.2168 43.8984 21.3594 43.8992 21.5026 43.8999L21.5743 43.9001H34.3193C35.1913 43.9001 35.7348 44.2764 35.8602 44.9513C36.0274 45.8471 35.4302 46.528 34.4268 46.5339C32.9896 46.5419 31.5525 46.5392 30.1153 46.5366C29.3966 46.5353 28.6774 46.5339 27.9588 46.5339L27.9647 46.5459Z",
    stroke: "url(#paint7_linear_1972_80267)",
    strokeWidth: 2.56
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5992 39.2796C28.1253 39.278 28.6515 39.2764 29.1783 39.2764V39.2824C29.6606 39.2824 30.3742 39.2834 31.1863 39.2845C33.2001 39.2873 35.819 39.2909 37.0149 39.2824C37.3016 39.2764 37.6062 39.2645 37.869 39.1689C38.4543 38.9539 38.7529 38.3447 38.6394 37.7057C38.5259 37.0667 37.9944 36.6486 37.2359 36.6486H23.8748C23.1522 36.7143 22.6386 37.2518 22.6326 37.9506C22.6266 38.6911 23.1343 39.2585 23.9047 39.2705C25.1378 39.2872 26.3679 39.2834 27.5992 39.2796Z",
    stroke: "url(#paint8_linear_1972_80267)",
    strokeWidth: 2.56
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1972_80267",
    x1: 0,
    y1: 96.3711,
    x2: 113.373,
    y2: 66.6559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF6D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFE3DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9DFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1972_80267",
    x1: 17.5481,
    y1: 66.9213,
    x2: 82.4086,
    y2: 39.0527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1972_80267",
    x1: 17.5481,
    y1: 66.9213,
    x2: 82.4086,
    y2: 39.0527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1972_80267",
    x1: 17.5481,
    y1: 66.9213,
    x2: 82.4086,
    y2: 39.0527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1972_80267",
    x1: 17.5481,
    y1: 66.9213,
    x2: 82.4086,
    y2: 39.0527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1972_80267",
    x1: 17.5481,
    y1: 66.9213,
    x2: 82.4086,
    y2: 39.0527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1972_80267",
    x1: 17.5481,
    y1: 66.9213,
    x2: 82.4086,
    y2: 39.0527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1972_80267",
    x1: 17.5481,
    y1: 66.9213,
    x2: 82.4086,
    y2: 39.0527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1972_80267",
    x1: 17.5481,
    y1: 66.9213,
    x2: 82.4086,
    y2: 39.0527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF451B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6928FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.977664a6fb9f981d5b06a58d5012a475.svg";
export { ForwardRef as ReactComponent };